import { useState } from "react";
import ManualNav from "./ManualNav";

export default function ManualFrame({ role, tree, meta, activeSlug, children }) {
  const [query, setQuery] = useState("");

  return (
    <div className="manual-book">
      <ManualNav role={role} tree={tree} activeSlug={activeSlug} query={query} onQuery={setQuery} />
      <div className="manual-sheet" id="manual-sheet">
        <p className="manual-kicker">{meta.kicker}</p>
        {children}
      </div>
    </div>
  );
}
